import api from '@/utils/axios';

const throwFrom = (raw, fallback) => {
  const payloadBody = raw?.response?.data;
  const err = new Error(payloadBody?.error?.message || raw?.message || fallback);
  err.code = payloadBody?.error?.code || '';
  err.status = raw?.response?.status || 0;
  err.data = payloadBody?.data ?? null;
  throw err;
};

const unwrap = (response, fallback) => {
  const payload = response?.data;
  if (!payload?.success) {
    const err = new Error(payload?.error?.message || fallback);
    err.code = payload?.error?.code || '';
    err.status = response?.status || 0;
    err.data = payload?.data ?? null;
    throw err;
  }
  return payload.data;
};

async function postAction(action, body, fallback) {
  try {
    const response = await api.post('complaints/manage', { action, ...body });
    return unwrap(response, fallback);
  } catch (raw) {
    if (raw instanceof Error && !raw.response) {
      throw raw;
    }
    throwFrom(raw, fallback);
  }
}

export const fetchComplaintOptions = () =>
  postAction('options', {}, 'Failed to load the form');

export const submitComplaint = (payload) =>
  postAction('submit', payload, 'Failed to send the message');

export const fetchComplaintStatus = (publicCode) =>
  postAction('status', { public_code: publicCode }, 'Failed to check that code');

export const fetchComplaints = (params = {}) =>
  postAction('list', params, 'Failed to load messages');

export const updateComplaint = (payload) =>
  postAction('update', payload, 'Failed to update the message');
